import { numberOrZero } from "@/utils/utils";
import { Popover } from "antd";
import { useTranslation } from "react-i18next";
import { tInterval } from "../../../../../../common/utils/translationUtils";
import { DashboardGoal } from "../../../../types";
import { getPercentage } from "../../../../utils";
import { GoalCard } from "../cards/GoalCard";

type Props = {
  goal: DashboardGoal;
  year: number;
  agentId: string;
};

export const TipperAllTraineesWrapper = ({ goal, year, agentId }: Props) => {
  const { t } = useTranslation();

  const actualValue = numberOrZero(goal.actualValue);
  const targetValue = numberOrZero(goal.targetValue);

  const currentPercentage = getPercentage(actualValue, targetValue);

  return (
    <GoalCard
      agentId={agentId}
      year={year}
      goal={goal}
      isGaugeStyle
      percentage={currentPercentage}
      label={
        <Popover content={t("dashboard.goals.helpers.traineesGoalHint")}>
          {t("dashboard.enums.dashboardGoalType.TIPPER_ALL_TRAINEES")}
        </Popover>
      }
      tooltipTitle={
        <p>
          {actualValue} {tInterval("dashboard.goals.helpers.trainees_interval", actualValue)}{" "}
          {t("dashboard.goals.helpers.from")} {targetValue}
        </p>
      }
      hasTarget
    />
  );
};
